import { useTheme } from '@mui/material/styles';
import { Text } from '@/components/atoms/text';
import { Link } from 'react-router-dom';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

type AnchorProps = {
  href?: string;
  label: any;
  underline?: 'underline' | 'none';
  primary?: boolean;
  secondary?: boolean;
  color?: string;
  fontSize?: number;
  fontWeight?: number;
  onClick?: () => void;
  target?: string;
  sx?: SxProps<Theme>;
};

export const Anchor = ({
  href,
  label,
  color,
  fontSize,
  fontWeight,
  underline = 'none',
  primary,
  secondary,
  onClick,
  target,
  sx,
}: AnchorProps) => {
  const theme = useTheme();

  const getColor = () => {
    if (primary) return theme.palette.info.main;
    if (secondary) return theme.palette.info.main;
    if (color) return color;
    return theme.palette.info.main;
  };

  return (
    <Link to={href ? href : '/'} target={target}>
      <Text
        role="link"
        variant="body2"
        sx={{
          cursor: 'pointer',
          textDecoration: underline,
          color: getColor(),
          fontSize,
          fontWeight,
          ...sx,
        }}
        onClick={onClick}
      >
        {label}
      </Text>
    </Link>
  );
};
